import { urlMap, getAuthHeaders } from '../utils';

export async function listChapterVideos(chapterId) {
  if (!chapterId) return [];
  const res = await fetch(urlMap.listChapterVideos(chapterId), {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Failed to list chapter videos');
  return res.json();
}
